// extracted by mini-css-extract-plugin
export default {"popupBody":"DiscardBilling_popupBody__UPjky","closeBtn":"DiscardBilling_closeBtn__d0bjf"};